import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';


export default class  AddLedger extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  	 leid:'',data:[],redirect: false,details:'',btndisabled:false,logredirect:false,pagename:'',
submitbtn:"Submit",open:false,ledgername:'',le_id:0,displayname:'',code:'',category:'',visibility:'',compid:'',
      errormessage:'',erropen:false,isvisibility:false,categorydisable:true,isbank:false,issales:false,isexpenses:false,otherpayments:false,otherreciepts:false,journals:false,
submitbtn:"Save",visibilitytype:[],strisbank:false,strissales:false,strisexpenses:false,strotherpayments:false,strotherreciepts:false,strjournals:false,strreports:false,categorygroup:'',
	   
	  }
      
  }
  
Ledgergetdata() {
  if (this.props.id !== 0) {
    axios.get(`${localStorage.getItem("ISIurl")}ajaxledger.php?action=getall&le_id=${this.props.id}&le_cmp_id=${localStorage.getItem("ISIcmpid")}`)
      .then(resp => {
        if (resp.data.length > 0) {
          const data = resp.data[0];

          // Convert string '1','0' to boolean
          const strisbank = data.le_isbank === "1";
          const strissales = data.le_issales === "1";
          const strisexpenses = data.le_isexpenses === "1";
          const strotherpayments = data.le_otherpayments === "1";
          const strotherreciepts = data.le_otherreciepts === "1";
          const strjournals = data.le_journals === "1";

          // Calculate categorygroup dynamically
          let categorygroup = 0;
          const cat = data.le_category;
		 if (["BANK","CURRENT_ASSETS","FUTURE_ASSETS","FUTURE_LIABILITY"].includes(cat)) categorygroup = "Assets";
          else if (["DEPRECIATION","DIRECT_EXPENSES","OVERHEADS"].includes(cat)) categorygroup = "Expenditure";
          else if (["SALES","FUTURE_LIABILITY"].includes(cat)) categorygroup = "Income";
          else if (["CREDIT_CARD_/_LOAN","CURRENT_LIABILITY","OTHER_INCOME"].includes(cat)) categorygroup = "Liability";
          else if (cat === "EQUITY") categorygroup = "Capital"; 



         /* if (["BANK","CURRENT_ASSETS","FUTURE_ASSETS","FUTURE_LIABILITY"].includes(cat)) categorygroup = 1;
          else if (["DEPRECIATION","DIRECT_EXPENSES","OVERHEADS"].includes(cat)) categorygroup = 2;
          else if (["FUTURE_LIABILITY","FUTURE_LIABILITY"].includes(cat)) categorygroup = 3;
          else if (["CREDIT_CARD_/_LOAN","CURRENT_LIABILITY","OTHER_INCOME"].includes(cat)) categorygroup = 4;
          else if (cat === "EQUITY") categorygroup = 5;*/

          this.setState({
            le_id: data.le_id,
            ledgername: data.le_ledgername,
            displayname: data.le_displayname,
            code: data.le_code,
            category: cat,
            selectcategory: cat,          
            categorygroup:categorygroup,                
            isbank: strisbank,
            issales: strissales,
            isexpenses: strisexpenses,
            otherpayments: strotherpayments,
            otherreciepts: strotherreciepts,
            journals: strjournals
          });
        }
      });
  } else {
 
    this.setState({ 
      le_id: 0,
      ledgername: '',
      displayname: '',
      code: '',
      category: '',
      selectcategory: '',
      categorygroup: 0,
      isbank: false,
      issales: false,
      isexpenses: false,
      otherpayments: false,
      otherreciepts: false,
      journals: false
    }); 
  }
}


onclickledgerclose = (e) => {
	 this.setState({open:false});
}


handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open, ledgername:'',le_id:0,code:'',displayname:'',category:'',visibility:'',compid:'',
     errormessage:'',erropen:false,catgroup:'',isvisibility:false,categorydisable:true,isbank:false,issales:false,isexpenses:false,
	 otherpayments:false,otherreciepts:false,journals:false,selectcategory:'',categorygroup:this.state.categorygroup,
submitbtn:"Save",
	  });
		this.Ledgergetdata();
		
};


 handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.isbank ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }


 handleissalesChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.issales ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
  
   handleisexpensesChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.isexpenses ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
  
   handleotherpaymentsChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.otherpayments ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
  
   handleotherrecieptsChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.otherreciepts ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
  
   handlejournalsChange = (event) => {
    const { name, checked } = event.target;

    this.setState({ [name]: checked }, () => {
      const updatedCheckboxData = [
   
     this.state.journals ? "1" : "0",];

      this.setState({ checkboxData: updatedCheckboxData }, () => {
      console.log("Checkbox Data:", this.state.checkboxData);
      });
    });
  }
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
 if(nam==="le_id")
{

 this.setState({[nam]: val},()=>{});

}	else{
  this.setState({[nam]: val},()=>{});
  }
}



handleSubmit = (event) => {
	 event.preventDefault();
 let ledgername = this.state.ledgername;
 let displayname = this.state.displayname;
 let code = this.state.code;
 let category = this.state.category;
 let categorygroup = this.state.categorygroup;
 let isbank = this.state.isbank;
 let issales = this.state.issales;
 let isexpenses = this.state.isexpenses;
 let otherpayments = this.state.otherpayments;
 let otherreciepts = this.state.otherreciepts;
 let journals = this.state.journals;



 let strisbank="0";
 if(isbank===true)
	{
		strisbank="1";
	}
	else{strisbank="0";}
	
let strissales="0";
 if(issales===true)
	{
		strissales="1";
	}
	else{strissales="0";}
	
	  let strisexpenses="0";
 if(isexpenses===true)
	{
		strisexpenses="1";
	}
	else{strisexpenses="0";}
	
	 
	 let strotherpayments="0";
 if(otherpayments===true)
	{
		strotherpayments="1";
	}
	else{strotherpayments="0";}
	
	  let strotherreciepts="0";
 if(otherreciepts===true)
	{
		strotherreciepts="1";
	}
	else{strotherreciepts="0";}
	
	  let strjournals="0";
	if(journals===true)
	{
		strjournals="1";
	}
	else{strjournals="0";}

if(ledgername==="")
{
	
	this.setState({errormessage:"Please Enter  Name ",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
	
}

if(displayname==="")
{
	
	this.setState({errormessage:"Please Enter  Display Name",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
	
}

if(code==="")
{
	
	this.setState({errormessage:"Please Enter  Code",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
	
}
if(category==="" || category==="0")
{
	
	this.setState({errormessage:"Please Select  Category",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
	
	
}
 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.le_id===0)
	  {
		  formData.append('le_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('le_id',this.state.le_id)
		
          }
	    formData.append('action','insertorupdate') 
		formData.append('le_ledgername',ledgername)
		formData.append('le_displayname',displayname)
		formData.append('le_code',code)
		formData.append('le_category',category)
		formData.append('le_categorygroup',categorygroup)
		formData.append('le_isbank',strisbank)
		formData.append('le_issales',strissales)
		formData.append('le_isexpenses',strisexpenses)
		formData.append('le_otherpayments',strotherpayments)
		formData.append('le_otherreciepts',strotherreciepts)
		formData.append('le_journals',strjournals)
		formData.append('le_cmp_id',localStorage.getItem("ISIcmpid"))
		formData.append('userid',localStorage.getItem("ISIuserid"))
		  
		axios.post(localStorage.getItem("ISIurl") +"ajaxledger.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
           this.props.updateledger();
    
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

categoryChange = (event) => {
  const nam = event.target.name;
  const val = event.target.value;

  let categorygroup = 0; 

  if (["BANK","CURRENT_ASSETS","FUTURE_ASSETS","FUTURE_LIABILITY"].includes(val)) categorygroup = "Assets";
          else if (["DEPRECIATION","DIRECT_EXPENSES","OVERHEADS"].includes(val)) categorygroup = "Expenditure";
          else if (["SALES","FUTURE_LIABILITY"].includes(val)) categorygroup = "Income";
          else if (["CREDIT_CARD_/_LOAN","CURRENT_LIABILITY","OTHER_INCOME"].includes(val)) categorygroup = "Liability";
          else if (val === "EQUITY") categorygroup = "Capital"; 
/* if (["1","3","8","9"].includes(val)) categorygroup = 1;       	
  else if (["5","6","12"].includes(val)) categorygroup = 2;     	
  else if (["13","10"].includes(val)) categorygroup = 3;        
  else if (["4","11","2"].includes(val)) categorygroup = 4;     
  else if (["7"].includes(val)) categorygroup = 5;   */          

  this.setState({ [nam]: val, selectcategory: val, categorygroup });
};

	 

render (){
const { ...props } = this.props;
return(
<React.Fragment>
<Dialog open={this.state.open} onClose={this.onclickledgerclose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Add New </DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
	<p> Name <span className="validation">*</span> </p>
	
	<p><TextField name="ledgername" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ledgername}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
						  
<p> Display Name <span className="validation">*</span> </p>
	
	<p><TextField name="displayname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.displayname}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>			
						  
	 <p>Code <span className="validation">*</span> </p>
	
	<p><TextField name="code" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.code}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
	
		
<p>Category <span className="validation">*</span></p>				  
<p><FormControl >
				
		 <Select
         native fullWidth
		 variant="outlined"
          margin="normal"
          onChange={this.categoryChange}
          id="type"
		   value={this.state.category} inputProps={{tabIndex: "4",maxLength:25}} className="txtbox"
		  name="category"
		>
	
	      <option value="Select">Select Category</option>
          <option value={"BANK"}>Bank</option>
          <option value={"CREDIT_CARD_/_LOAN"}>Credit Card / Loan</option>
          <option value={"CURRENT_ASSETS"}>Current Assets</option>
		  <option value={"CURRENT_LIABILITY"}>Current Liability</option>
          <option value={"DEPRECIATION"}>Depreciation</option>
          <option value={"DIRECT_EXPENSES"}>Direct Expenses</option>
		  <option value={"EQUITY"}>Equity</option>
		  <option value={"FIXED_ASSETS"}>Fixed Assets</option>
          <option value={"FUTURE_ASSETS"}>Future Assets</option>
          <option value={"FUTURE_LIABILITY"}>Future Liability</option>
		  <option value={"OTHER_INCOME"}>Other Income</option>
          <option value={"OVERHEADS"}>Overheads</option>
          <option value={"SALES"}>Sales</option>
         </Select>
         </FormControl>
		</p>			
		






<p> Category Group <span className="validation">*</span> </p>
<p><FormControl >
				
		 <Select
         native fullWidth
		 variant="outlined"
          margin="normal"
         id="categorygroup"
		  disabled={this.state.categorydisable}
		   onChange={this.myChangeHandler} 
		 value={this.state.categorygroup} inputProps={{tabIndex: "4",maxLength:25}} className="txtbox"
		 name="categorygroup"
		>
		
	
	{(
  this.state.selectcategory === "BANK" ||
  this.state.selectcategory === "CURRENT_ASSETS" ||
  this.state.selectcategory === "FIXED_ASSETS" ||
  this.state.selectcategory === "FUTURE_ASSETS"
) && (
  <option value={"Assets"}>Assets</option>
)}


{(
  this.state.selectcategory === "DEPRECIATION" ||
  this.state.selectcategory === "DIRECT_EXPENSES" ||
  this.state.selectcategory === "OVERHEADS" 
 
) && (
<option value={"Expenditure"}>Expenditure</option>
)}
		  
	{(
  this.state.selectcategory === "SALES"  || 
   this.state.selectcategory === "FUTURE_LIABILITY"  
 
 
) && (
<option value={"Income"}>Income</option>
)}
		

{(
  this.state.selectcategory === "CURRENT_LIABILITY"  || 
   this.state.selectcategory === "OTHER_INCOME"  ||
   this.state.selectcategory === "CREDIT_CARD_/_LOAN"
 
 
) && (
<option value={"Liability"}>Liability</option>
)}




{(this.state.selectcategory === "EQUITY") && (
<option value={"Capital"}>Capital</option>
)}

	

		
         </Select>
         </FormControl>
		</p>			
		





						  
	
		  <h2>Visibility</h2>
		  <p> <FormControlLabel
         control={
        <Checkbox
            name="isbank"
            checked={this.state.isbank} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='Bank'
       /> 
      </p>

	  <p> <FormControlLabel
         control={
        <Checkbox
            name="issales"
            checked={this.state.issales} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label=' Sales - Invoice / Credit, Product / Services / Customer defaults'
       /> 
      </p>
	  
	    <p> <FormControlLabel
         control={
        <Checkbox
            name="isexpenses"
            checked={this.state.isexpenses} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='Expenses - Bill / Credit, Product / Vendor defaults'
       /> 
      </p>


   <p> <FormControlLabel
         control={
        <Checkbox
            name="otherpayments"
            checked={this.state.otherpayments} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='Other Payment'
       /> 
      </p>
	  
	   <p> <FormControlLabel
         control={
        <Checkbox
            name="otherreciepts"
            checked={this.state.otherreciepts} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='Other Reciepts'
       /> 
      </p>
	  
	     <p> <FormControlLabel
         control={
        <Checkbox
            name="journals"
            checked={this.state.journals} 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='journals'
       /> 
      </p>

						  
	   <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickledgerclose}>
Cancel
</Button>
</div> 
<div className="savebtn">

	  {this.state.erropen===true &&(
	  <span className="validation"> {this.state.errormessage} <CloseIcon fontSize="inherit" onClick={() => {
               this.handleErrorclose();
              }}/></span>
	  )}
&nbsp;<Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  